import React from 'react';
import { connect } from 'react-redux';
// import DemoBox from "../demobox/DemoBox";
// import Select from 'react-select';
// import jsonp from 'jsonp';
// import axios from 'axios';
//style
import './demosection.styl';
import 'react-select/dist/react-select.css';

import {DemoSectionText as DemoSectionTextEN } from '../../input-text/en/demosection';
import {DemoSectionText as DemoSectionTextNL } from '../../input-text/nl/demosection';

class DemoSection extends React.Component {
    constructor(props){
        super(props);
        this.setLocale = this.setLocale.bind(this);
    }

    componentDidMount() {
        const script = document.createElement('script');
        script.src = 'https://widget.aircheckr.com/js/client.widget.js';
        script.async = true;

        document.body.appendChild(script);
    }

    setLocale(locale) {
      this.DemoSectionText = null;
      switch (this.props.locale) {
          case 'en':
              this.DemoSectionText = DemoSectionTextEN;
              break;
          case 'nl':
              this.DemoSectionText = DemoSectionTextNL;
              break;
          default:
              this.DemoSectionText = DemoSectionTextEN;
      }
    }

    render(){
        this.setLocale(this.props.locale);

        return (
            <div>
                <div style={{ margin: '30px 0 20px', minHeight: '200px'}}>
                    <article
                        className="ac-aircheckr-widget"
                        data-theme="dark"
                        data-locale={ this.props.locale === 'en' ? 'en_GB' : 'nl_BE' }
                        data-type="extended"
                        data-level="street"
                        data-token="eyJhbGciOiJIUzI1NiJ9.NWNiMmUwNjAtYTJiMC0xMWU3LTgwNjYtNmI2ZTg4ZGUwNGU5.o3wnCw4DXe9L7K_MkhuJr7q5wT8DzYOvedBwJkAnL8I"
                      >
                     </article>
                </div>
                <div className="demo-section__cta">
                    <p className="demo-section__cta__intro">{ this.DemoSectionText.invite }</p>
                    <a className="button" href="/signup/">{ this.DemoSectionText.cta }</a>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

export default connect(mapStateToProps)(DemoSection);



// WEBPACK FOOTER //
// ./src/components/demosection/DemoSection.js